import { CheckCircle2, ArrowRight } from "lucide-react";

const BOOK_URL = "https://kneadrelief.noterro.com/";

const POINTS = [
  { title: "Fully clothed therapy", desc: "No need to undress — wear comfortable, loose-fitting clothes." },
  { title: "Active participation", desc: "You move with carefully prescribed patterns while I work the tissue." },
  { title: "Science-based", desc: "Neurologically focused, designed to reset the nervous system." },
  { title: "Canadian-developed", desc: "A modern, innovative technique pioneered right here in Canada." },
];

export default function RapidExplainer() {
  return (
    <section
      id="rapid"
      data-testid="rapid-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-[#0B2A46] text-white overflow-hidden"
    >
      <div className="absolute inset-0 -z-0">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full bg-sky-500/15 blur-[140px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-300 mb-4">
              The Difference
            </div>
            <h2
              data-testid="rapid-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] text-white"
            >
              What is{" "}
              <span className="text-sky-300">RAPID NeuroFascial Reset?</span>
            </h2>
            <p className="mt-5 text-blue-100/80 text-lg leading-relaxed">
              RAPID is unlike any therapy you've had before. Instead of passively receiving
              treatment, you move with carefully prescribed patterns while I work with your muscles —
              reducing pain and unlocking range of motion fast.
            </p>
            <p className="mt-4 text-blue-100/70 leading-relaxed">
              I'm proud to be one of the elite RAPID NFR Specialists — a small cadre of therapists
              who are among the most highly trained in the world for this technique.
            </p>

            <a
              href={BOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="rapid-book-now"
              className="mt-8 inline-flex items-center gap-2 bg-white text-blue-900 hover:bg-blue-50 rounded-full px-6 py-3.5 font-semibold transition-all hover:-translate-y-0.5 shadow-lg shadow-black/20"
            >
              Experience the RAPID difference
              <ArrowRight size={18} strokeWidth={2.2} />
            </a>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {POINTS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`rapid-point-${i}`}
                  className="bg-white/[0.06] backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/[0.09] hover:border-sky-300/30 transition-all"
                >
                  <CheckCircle2 size={22} strokeWidth={1.8} className="text-sky-300 mb-3" />
                  <div className="font-display font-bold text-lg text-white mb-1.5">{p.title}</div>
                  <div className="text-sm text-blue-100/70 leading-relaxed">{p.desc}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 bg-gradient-to-br from-white/[0.08] to-transparent border border-white/10 rounded-2xl p-6">
              <div className="text-xs uppercase tracking-[0.18em] text-blue-300 font-semibold mb-2">
                Honest note
              </div>
              <p className="text-blue-50/90 leading-relaxed">
                RAPID isn't always the most comfortable — but it's fast, effective and powerful.
                If you've tried everything for your pain and nothing has worked, you've not yet tried RAPID.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
